import { useEffect } from 'react';

import {
  removeVisibleRemoteContext,
  setVisibleRemoteContext,
} from '../utils/monitoring';

type UseRemoteProps = {
  scope: string;
  module: string;
};

export const useRemoteIsVisible = ({ scope, module }: UseRemoteProps) => {
  // Set the visible remote context for monitoring
  useEffect(() => {
    setVisibleRemoteContext(scope, module);

    return () => {
      removeVisibleRemoteContext(scope, module);
    };
  }, [scope, module]);
};
